import { render, staticRenderFns } from "./LeftTextBorderMany.vue?vue&type=template&id=4f31b38a&scoped=true"
import script from "./LeftTextBorderMany.vue?vue&type=script&lang=js"
export * from "./LeftTextBorderMany.vue?vue&type=script&lang=js"
import style0 from "./LeftTextBorderMany.vue?vue&type=style&index=0&id=4f31b38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31b38a",
  null
  
)

export default component.exports